export default __webpack_public_path__ + "static/media/ars_hdf_logo.dfe2916d.svg";